import { jsxs, jsx } from 'react/jsx-runtime';
import { InteractiveTagIcon } from './InteractiveTagIcon.es.js';
import { InteractiveTagWrapper } from './InteractiveTagWrapper.es.js';

const InteractiveTag = ({ children, color = "primary", href, iconAfter, iconAfterAriaHidden = true, iconAfterAriaLabel, iconBefore, iconBeforeAriaHidden = true, iconBeforeAriaLabel, onClick, maxWidth = "none" }) => {
  return jsxs(InteractiveTagWrapper, { color, href, onClick, maxWidth, children: [iconBefore && jsx(InteractiveTagIcon, { "aria-hidden": iconBeforeAriaHidden, "aria-label": iconBeforeAriaLabel, name: iconBefore, position: "before" }), children, iconAfter && jsx(InteractiveTagIcon, { "aria-hidden": iconAfterAriaHidden, "aria-label": iconAfterAriaLabel, name: iconAfter, position: "after" })] });
};

export { InteractiveTag };
//# sourceMappingURL=InteractiveTag.es.js.map
